export default (state = null, action) => {
  switch (action.type) {
    case "AUTH_SUCCESS_ADMIN":
      return 1;
    case "AUTH_SUCCESS_CUSTOMER":
      return 3;
    case "AUTH_FAIL":
      return 0;
    default:
      return state;
  }
};
